import React from 'react'
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import LandingPage from './pages/landing-page'
import SearchList from './pages/search-list'
import Timeout from './pages/timeout'
import Login from './pages/login'
import ErrorPage from './pages/error'
import AccountErrorPage from './pages/account-error'
import Info from './pages/info'
import MyRota from './pages/my-rota'
import { TheSideBar } from './components/sidebar'
import Sites from './pages/sites'
import Pages from './pages/pages'
import NewsDetails from './pages/news-details'

import { useUserState } from 'store/user-context'

function Authy({ component: Component }) {
  const state = useUserState()
  return state.initial_load_complete ? <Component /> : <Login />
}

const AppRoute = () => {
  return (
    <div className="min-h-screen">
      <TheSideBar />
      <Router>
        <Routes>
          <Route path="/search" element={<Authy component={SearchList} />} />
          <Route path="/info" element={<Info />} />
          <Route path="/error" element={<ErrorPage />} />
          <Route path="/account-error" element={<AccountErrorPage />} />
          <Route path="/timeout" element={<Timeout />} />
          <Route path="/myrota" element={<MyRota />} />

          <Route exact path="/sites" element={<Authy component={Sites} />} />
          <Route
            path="/sites/:siteName?/:rootPage?/:sub1?/:sub2?"
            element={<Authy component={Pages} />}
          />
          <Route path="/news/:id" element={<Authy component={NewsDetails} />} />
          <Route path="/" exact element={<Authy component={LandingPage} />} />
        </Routes>
      </Router>
    </div>
  )
}

export default AppRoute
